import CommonContainer from "../../Container/CommonContainer";
import { FaToggleOn, FaToggleOff, FaPen, FaBars, FaTrash, FaPlus } from "react-icons/fa";
import * as CallTypeService from "../../../Services/Masters/CallType/CallTypeService";
import toast from "react-hot-toast";
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";

const CallTypeComponent = () =>{

    const { register, handleSubmit, formState: { errors }, reset, } = useForm();

    const [callTypeList, setCallTypeList] = useState([]);
    const [selectedCallType, setSelectedCallType] = useState({});
    const [newCallTypeModal, setNewCallTypeModal] = useState(false);
    const [editCaseCategoryMappingModal, setEditCaseCategoryMappingModal] = useState(false);
    const [caseCategoryList, setCaseCategoryList] = useState([]);
    const [currentCallTypeId, setCurrentCallTypeId] = useState(null);
    const [changeInMapping, setChangeInMapping] = useState(false);

    const fetchAllCallTypeMasterList = () => {
        CallTypeService.GetCallTypeList(callTypeList)
          .then(({ data }) => {
            if (data.IsSuccess) {
              setCallTypeList(data.Data);
            }
          })
          .catch(() => toast.error("Something went wrong."));
    };

    const getMappedAndUnmappedCaseCategoryList = (Id) =>{
      CallTypeService.GetMappedAndUnmappedCaseCategoryList(Id)
      .then(({data}) =>{
        if(data.IsSuccess){
          setCaseCategoryList(data.Data);
          setEditCaseCategoryMappingModal(true);
          //console.log(data.Data);
        }
      });
    }

    useEffect(() => {
        fetchAllCallTypeMasterList();
    },[]);

    const onSubmit = (data) => {
      if (selectedCallType?.CallTypeId) {
        data.CallTypeId = selectedCallType?.CallTypeId;
        CallTypeService.UpdateCallType(data)
          .then(({ data }) => {
            if (data.IsSuccess) {
              fetchAllCallTypeMasterList();
              toast.success("Call Type updated successfully!");
              handleNewCallTypeModalClose();
            } else {
              toast.error("Something went wrong during update.");
            }
          })
          .catch(() => toast.error("Something went wrong during update."))
          .finally(() => { });
      } else {
        CallTypeService.CreateNewCallType(data)
          .then(({ data }) => {
            if (data.IsSuccess) {
              fetchAllCallTypeMasterList();
              toast.success("Call Type saved successfully!");
              handleNewCallTypeModalClose();
            } else {
              toast.error(data.ResponseMessage);
            }
          })
          .catch(() => toast.error("Something went wrong during creation."))
          .finally(() => { });
      }
    };

    const onMappingModalSubmit = (data) =>{
      CallTypeService.MapCallType_CaseCategory(caseCategoryList)
      .then(({ data }) => {
        if (data.IsSuccess) {
          toast.success("Call Type, Case category mapping updated successfully!");
          handleNewCallTypeModalClose();
        } else {
          toast.error("Something went wrong during update.");
        }
      })
      .catch(() => toast.error("Something went wrong during update."))
      .finally(() => { 
        setChangeInMapping(false);
      });
    }

    const handleMappingDelete = (categoryId) =>{
      setChangeInMapping(true)
      const updatedList = caseCategoryList.map(item =>
        item.CaseCategory_Id === categoryId
          ? { ...item, IsDeleted: true, IsSelected: false, CallType_Id: currentCallTypeId }
          : item
      );
      setCaseCategoryList(updatedList);
    }

    const handleMappingInsert = (categoryId) =>{
      setChangeInMapping(true)
      const updatedList = caseCategoryList.map(item =>
        item.CaseCategory_Id === categoryId
          ? { ...item, IsSelected: true, IsDeleted: false, CallType_Id: currentCallTypeId }
          : item
      );
      setCaseCategoryList(updatedList);
    }

    const handleNewCallTypeModalClose = () => {
      reset();
      setSelectedCallType([]);
      setNewCallTypeModal(false)
      if(changeInMapping === false){
        setCaseCategoryList([]);
        setCurrentCallTypeId(null);
        setEditCaseCategoryMappingModal(false);
      }
      else{
        toast.error("Please save the mapping changes first");
      }
      
    };

    const handleNewCallTypeMappingModalClose = () =>{
      setCaseCategoryList([]);
      setCurrentCallTypeId(null);
      setEditCaseCategoryMappingModal(false);
      setChangeInMapping(false)
      if(changeInMapping === true){
        toast.error("Mapping change not saved");
      }
    }

    const handleActivateDeActivateCallType = (rec) =>{
      CallTypeService.ActivateDeActivateCallType(rec.CallTypeId, !rec.IsActive).then(data => {
        if (data.data.IsSuccess) {
          const message = rec.IsActive ? "Call Type DeActivated Successfully" : "Call Type Activated Successfully";
          toast.success(message);
          fetchAllCallTypeMasterList();
        } else {
          toast.error("Somthing went wrong");
        }
        //console.log("data", data)
      }).catch(error => {
        toast.error("Somthing went wrong");
      })
    }

    const handleViewCallTypeDetailById = (CallTypeId) => {
      const selectedItem = callTypeList.find(item => item.CallTypeId === CallTypeId);
      if(selectedItem != null){
        setSelectedCallType(selectedItem);
        setNewCallTypeModal(true);
      }
      else{
        selectedCallType({});
      }
    };

    const handleViewCallTypeMappingDetails= (CallTypeId)=>{
      setCurrentCallTypeId(CallTypeId);
      getMappedAndUnmappedCaseCategoryList(CallTypeId);
    }

    return (
        <>
          {/* <LoadingSpinnerComponent></LoadingSpinnerComponent> */}
          <CommonContainer heading="Call Type List" buttonText="Add Call Type" onButtonClick={() => { reset(); setSelectedCallType([]); setNewCallTypeModal(true) }}>
    
            <div className="d-flex align-items-center justify-content-between mb-2">
              <div className="d-flex align-items-center gap-2">
              </div>
              {/* <div className="search-box" style={{ position: "relative", width: "320px" }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  //ref={selectedSearchUser}
                  style={{
                    paddingRight: "35px",
                    borderRadius: "5px",
                    border: "1px solid #ddd",
                  }}
                />
                <button
                  type="button"
                  className="btn btn-success d-flex align-items-center justify-content-center"
                  style={{
                    padding: '5px',
                    position: "absolute",
                    right: "0px",
                    height: "35px",
                    width: "45px",
                    top: "50%",
                    borderTopLeftRadius: "0",
                    borderBottomLeftRadius: "0",
                    transform: "translateY(-50%)",
                  }}
                  //onClick={fetchUniversalFilterUserData}
                >
                  <FaSearch />
                </button>
    
              </div> */}
            </div>
            <div>
              <div className="table-responsive" >
                <table className="table table-bordered custom-table" >
                  <thead>
                    <tr>
                      <th> Call Type</th>
                      <th> Active </th>
                      <th> Action </th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      callTypeList.length > 0 ? (
                        callTypeList.map((rec, index) => (
                          <tr key={index} >
                            <td>{rec.CallType}</td >
                            <td>
                              {rec.IsActive ? <FaToggleOn title="Deactivate CallType" onClick={() => handleActivateDeActivateCallType(rec)} color="green" size={16} /> : <FaToggleOff onClick={() => handleActivateDeActivateCallType(rec)} title="Activate CallType" color="red" size={16} />}
                            </td>
                            <td>
                              {/* <FaPenSquare color="green" className="mr-2 cursor-pointer" size={25} onClick={() => handleViewUserDetailById(rec.UserId)} title="Edit User" /> */}
                              <FaPen color="green" className="mr-2 cursor-pointer" onClick={() => handleViewCallTypeDetailById(rec.CallTypeId)} title="Edit CallType" />
                              <FaBars color={"green"} onClick={() => handleViewCallTypeMappingDetails(rec.CallTypeId)} title="Edit Case Category Mapping"/>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr><td colSpan="9" className="text-center" > No Data found </td></tr >
                      )}
                  </tbody>
                </table>
              </div>
            </div>

            {newCallTypeModal && (
            <div className="modal-backdrop">
              <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-lg custom-modal" role="document">
                  <div className="modal-content mb-0 p-0">
                    <div className="modal-header p-2-5">
                      <h5 className="modal-title">{selectedCallType?.CallType ? "Edit Call Type" : "New Call Type"}</h5>
                      <button type="button" className="btn-close" onClick={handleNewCallTypeModalClose}></button>
                    </div>
                    <div className="modal-body p-1">
                      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                        <div className="container mb-0" style={{ fontSize: "13px" }}>

                          <div className="row">

                            <div className="col-md-4 mb-2">
                              <label className="fw-bold required mb-0-5">Call Type</label>
                              <input type="text" className="form-control" placeholder="Enter Call Type" {...register("CallType", { required: "Call Type is required" })} defaultValue={selectedCallType?.CallType || ""} />
                              {errors.CallType && <p className="text-danger required_error">{errors.CallType.message}</p>}
                            </div>
                          </div>
                        </div>

                        <div className="modal-footer mt-0 mb-0 pt-1 pb-0 pr-1">
                          <button type="button" className="btn btn-danger" onClick={handleNewCallTypeModalClose}>Close</button>
                          <button type="submit" className="btn btn-primary">{selectedCallType?.CallTypeId ? "Update" : "Save"}</button>
                        </div>

                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {editCaseCategoryMappingModal && (
            <div className="modal-backdrop">
              <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-lg custom-modal" style={{maxWidth: "650px", width: "90%"}}  role="document">
                  <div className="modal-content mb-0 p-0">
                    <div className="modal-header p-2-5">
                      <h5 className="modal-title">Edit Case Category Mapping</h5>
                      <button type="button" className="btn-close" onClick={handleNewCallTypeModalClose}></button>
                    </div>
                    <div className="modal-body p-1">
                      <form onSubmit={handleSubmit(onMappingModalSubmit)} autoComplete="off">
                        <div className="container mb-0" style={{ fontSize: "13px" }}>
                          <div className="row" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                            {caseCategoryList.map((item, index) => item && item.IsActive ? (
                              <div className="col-12" key={index}>
                                <div className="form-check d-flex align-items-center border-bottom pb-2 mb-2">
                                <label className="form-check-label fw-bold me-3">{item.CaseCategory}</label>

                                  <div className="ms-auto">
                                  {item.IsSelected ? 
                                     <FaTrash color="red" className="mr-2 cursor-pointer" onClick={() => handleMappingDelete(item.CaseCategory_Id)} title="Delete Mapping" />
                                    : <FaPlus color="green" className="mr-2 cursor-pointer" onClick={() =>handleMappingInsert(item.CaseCategory_Id)} title="Add Mapping" />
                                  }
                                  </div>
                                </div>
                            </div>
                            ) : null
                          )}
                          </div>
                        </div>

                        <div className="modal-footer mt-0 mb-0 pt-1 pb-0 pr-1">
                          <button type="button" className="btn btn-danger" onClick={handleNewCallTypeMappingModalClose}>Close</button>
                          <button type="submit" className="btn btn-primary">{selectedCallType?.CallTypeId ? "Update" : "Save All"}</button>
                        </div>

                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
    
          </CommonContainer >
        </>
      );
}

export default CallTypeComponent